import React from "react";
import FriendlyDate from "./FriendlyDate";
import WeatherTemperature from "./WeatherTemperature";
import "./WeatherInfo.css";


export default function WeatherInfo(props) {
    return (
    <div className= "WeatherInfo">
        <h1>{props.info.name}</h1>
    <ul>
        <li>
            <FriendlyDate date={new Date(props.info.dt *1000)} />
        </li>
        <li className="text-capitalize">{props.info.weather[0].description}</li>
    </ul>
  <div className="row mt-3">
    <div className="col-6">
        <div className="clearfix">
            <div className="float-left">
        <img src={`http://openweathermap.org/img/wn/${props.info.weather[0].icon}@2x.png`}
        alt="icon" />
        </div>
      <div className="float-left">
       <WeatherTemperature celsius={props.info.main.temp} unit={props.unit} setUnit={props.setUnit} />
      </div>
    </div>
</div>
    <div className="col-6">
        <ul>
            <li>Humidity: {props.info.main.humidity}%</li>
            <li>Wind: {Math.round(props.info.wind.speed)} km/h</li>
        </ul>
    </div>
  </div>
</div>
    );
}